module.exports = __webpack_public_path__ + "img/hw-s5.4ac894c2.svg";